import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import { FaInstagram, FaEnvelope, FaShoppingCart, FaApple, FaGooglePlay } from 'react-icons/fa';

const Footer = () => {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
        window.scrollTo(0, 0);
    };

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section">
                    <h3>Contato e Redes Sociais</h3>
                    <div className="social-links">
                        <a href="https://www.instagram.com/reinoflixoficial?igsh=MTdtazl3OXpoM3cwdg==" target="_blank" rel="noopener noreferrer" title="Instagram">
                            <FaInstagram />
                        </a>
                        <a href="mailto:suporteturminha@gmail.com" title="Email">
                            <FaEnvelope />
                        </a>
                        <a href="https://reinoflix.com" target="_blank" rel="noopener noreferrer" title="Loja">
                            <FaShoppingCart />
                        </a>
                    </div>
                </div>

                <div className="footer-section">
                    <h3>Links Úteis</h3>
                    <div className="useful-links">
                        <button onClick={() => handleNavigation('/privacy-policy')} className="footer-link-button">
                            Política de Privacidade
                        </button>
                        <button onClick={() => handleNavigation('/terms-of-service')} className="footer-link-button">
                            Termos de Serviço
                        </button>
                        <a href="https://reinoplay.online/central-de-ajuda" target="_blank" rel="noopener noreferrer">
                            Central de Ajuda
                        </a>
                    </div>
                </div>

                <div className="footer-section">
                    <h3>Baixe nosso App</h3>
                    <div className="store-buttons">
                        <a href="https://apps.apple.com/br/app/reino-play/id6752254183" target="_blank" rel="noopener noreferrer" className="store-button-link">
                            <FaApple />
                            <span>App Store</span>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=app.reinoplay.mobile&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="store-button-link">
                            <FaGooglePlay />
                            <span>Google Play</span>
                        </a>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Reino Play. Todos os direitos reservados.</p>
            </div>
        </footer>
    );
};

export default Footer; 